module.exports = __webpack_public_path__ + "static/2-75d4f5dec965dc9ab834f874386ae046.png";